import React, { useEffect, Component } from "react";
import PropTypes from "prop-types";
import { CardDetailImage, CardDetailContent } from "components/CardDetail";
import { Grid } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { fetchDetailProductRequest } from "redux/ActionCreators/ProductActionCreators";
import { FacebookProvider, Comments } from "react-facebook";

const CardDetailContainer = (props) => {
  const { id } = props;
  const dispatch = useDispatch();
  const product = useSelector((state) => state.products.detail);

  useEffect(() => {
    dispatch(fetchDetailProductRequest(id));
  }, [id]);

  if (!product) return <div>Loading...</div>;

  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={7}>
          <CardDetailImage imgPathRegex={product.imageRegex} />
        </Grid>
        <Grid item xs={12} sm={5}>
          <CardDetailContent
            id={product.id}
            title={product.name}
            price={product.price}
            priceDiscount={product.priceDiscount}
            rating={product.rating}
            description={product.description}
            imgPathRegex={product.imageRegex}
            numberProductSold={product.numberProductSold}
          />
        </Grid>
      </Grid>

      <div style={{ marginTop: "20px" }}>
        <FacebookProvider appId="374791463650542">
          <Comments href={product.linkFacebook} />
        </FacebookProvider>
      </div>
    </div>
  );
};

CardDetailContainer.propTypes = {
  id: PropTypes.number.isRequired,
};

export default CardDetailContainer;
